<div *ngIf="isLoading | async" class="overlay">
    <div class="loader">
    </div>
</div>
